export enum MedicalRecordFormStatus {
  PUBLISHED = 'PUBLISHED',
  PENDING_FILLING = 'PENDING_FILLING',
  EXPIRED = 'EXPIRED',
}